import { createRootRoute } from '@tanstack/react-router';

import { RootRouteComponent } from '@/views/RootRoute';
export const rootRoute = createRootRoute({
	component: RootRouteComponent,
});
